import { render } from "./PathTree.vue?vue&type=template&id=76f06d8f&ts=true"
import script from "./PathTree.vue?vue&type=script&lang=ts"
export * from "./PathTree.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__